import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { LoginWrapper } from "../Components/Login/Login";
import { useNavigate, useParams } from "react-router-dom";
import { Language } from "../Components/Login/Language";
import { Logo } from "../Components/Login/Logo";
import { HelpText } from "../Components/Login/HelpText";

import UserService from "../Services/UserService";
import useMessage from "../Hooks/useMessage";
import { PasswordRecoverForm } from "../Components/Recover/PasswordRecoverForm";

export function PasswordRecover() {
  let navigate = useNavigate();
  let params = useParams();
  const { t, i18n } = useTranslation();

  const {  addMessage } = useMessage();
  const [passwordNew, setPasswordNew] = useState("");
  const [passwordNewConfirm, setPasswordNewConfirm] = useState("");

  const handlePasswordNew = (event) => {
    setPasswordNew(event.target.value);
  };
  const handlePasswordNewConfirm = (event) => {
    setPasswordNewConfirm(event.target.value);
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();

    if (passwordNew != passwordNewConfirm) {
      addMessage(t("comp.confirmNewPassWarn"), "warn");
      return;
    }
    if (passwordNew.length < 8 || passwordNewConfirm.length < 8) {
      addMessage(t("comp.pass8symbol"), "warn"); 
      return;
    }
    if (!params.token) {
      navigate("/");
      addMessage(t("comp.noToken"), "warn");
      return;
    }
    
    UserService.recoverByToken({
      token: params.token,
      password: passwordNew,
    }).then(
      (response) => {
        if (response?.data?.message) {
          localStorage.removeItem("bolashak_token");
          navigate("/login");
          addMessage(response?.data?.message, "success");
        }
      },
      (error) => {
        navigate("/login");
       }
    );
  };

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <LoginWrapper>
      <Language changeLanguage={changeLanguage} />
      <Logo />
      <HelpText />
      <PasswordRecoverForm
        handlePasswordNew={handlePasswordNew}
        handlePasswordNewConfirm={handlePasswordNewConfirm}
        handlePasswordSubmit={handlePasswordSubmit}
        passwordNew={passwordNew}
        passwordNewConfirm={passwordNewConfirm}
      />
    </LoginWrapper>
  );
}
